import React from "react";
import { Datepicker, DatepickerEvent, DatepickerClasses } from "@meinefinsternis/react-horizontal-date-picker";
import { ru } from "date-fns/locale";

interface CalendarComponentProps {
  startDateName: string;
  endDateName: string;
  classes?: Partial<DatepickerClasses>;
  getValues: (name: string) => any;
  setValue: any;
}

const CalendarComponent = ({ 
  startDateName, 
  endDateName, 
  classes,
  getValues,
  setValue 
}: CalendarComponentProps) => {

  const defaultClasses: DatepickerClasses = {
    selectedDay: "datepicker-selectedDay",
    rangeDays: "datepicker-rangeDays",
    dayItem: "datepicker-dayItem",
    dayLabel: "datepicker-dayLabel",
    monthLabel: "datepicker-monthLabel",
    dateLabel: "datepicker-dateLabel",
    weekendItem: "datepicker-weekendItem",
    ...classes
  };

  const handleChange = (event: DatepickerEvent) => {
    const [startValue, endValue] = event;
    setValue(startDateName, startValue, { shouldValidate: true });
    setValue(endDateName, endValue, { shouldValidate: true });
  };

  return (
    <Datepicker
      onChange={handleChange}
      locale={ru}
      startValue={getValues(startDateName)}
      endValue={getValues(endDateName)}
      classNames={defaultClasses}
    />
  );
};

export default CalendarComponent;